(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let ReviewSwiper = null;

    function initReviewSwiper() {
      if (ReviewSwiper) {
        ReviewSwiper.destroy(true, true);
        ReviewSwiper = null;
      }

      ReviewSwiper = new Swiper('.reviews-swiper', {
        pagination: {
          el: '.reviews-swiper .swiper-pagination',
          type: 'progressbar',
          clickable: false,
        },
        spaceBetween: 16,
        navigation: {
          nextEl: '.reviews-swiper .swiper-button-next',
          prevEl: '.reviews-swiper .swiper-button-prev',
        },
        mousewheel: true,
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            mousewheel: false,
          },
          768: {
            slidesPerView: 1,
          },
          991: {
            slidesPerView: 2,
          },
          1200:{
            slidesPerView: 2.4,
          },
        },
      });

      // Toggle visibility of navigation and pagination
          }

    initReviewSwiper();
    window.addEventListener('resize', initReviewSwiper);
  });

  } catch(e) { console.error(e); }
})();
})();
